import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ItemSucursalRe from './ItemSucursalRe';
const server = process.env.REACT_APP_SERVER;

function HistoricoInventarioTr() {
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [idUsuario, setIdUsuario] = useState(JSON.parse(localStorage.getItem('info')).ID_EMPLEADO);
    const [sucursales, setSucursales] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [fecha, setFecha] = useState('');
    const [numFila,setNumFila] = useState(0);
    function sumarValores(columna) {
        var table = document.getElementById('invHisTabla')
        try{
            var tr = table.getElementsByTagName("tr");
            var suma = 0
            var i;
            for (i = 0; i < tr.length; i++) {
                var td = tr[i].getElementsByTagName("td")[columna];
                if (td) {
                    var txtValue = td.textContent || td.innerText;

                    if (txtValue.includes('+')) {
                        // Si tenemos el simbolo mas (+) debemos separar ambos miembros
                        var datos = txtValue.split('+')
                        suma = suma + (parseInt(datos[0])*100) + parseInt(datos[1]);
                    } else {
                        // Solo sumamos si es un numero valido
                        var valor = parseFloat(txtValue);
                        if (!isNaN(valor)) {
                            suma = suma + valor;
                        }
                    }

                    /*if (txtValue != '?' && txtValue != 'ERR'&&!isNaN(txtValue)&&txtValue!='') {
                        if(columna==2){
                            var datos = txtValue.split('+')
                            suma = suma + (parseInt(datos[0])*100)+parseInt(datos[1])
                        }else{
                            suma = suma + parseFloat(txtValue)
                        }
                    }*/
                }
            }

            // Formato del total
            if(columna == 2){
                var resultado = `${parseInt(suma/100)} + ${parseInt(suma%100)}`
                return resultado
            }else{
                return suma
            }
        }catch{
            return 0
        }
    }
    function actualizarSuma(){
        setNumFila(numFila=>numFila+1);
    }
    useEffect(() => {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    //getInformacionProyeccion();
                    //console.log(data.ok)
                    setSucursales(data.ok);
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='btn-group'>
                    <div className="input-group input-group-sm" style={{ width: '175px' }}>
                        <span className="text-light mx-1 my-auto" >Fecha</span>
                        <input type="date" className="form-control" placeholder="Username" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                    </div>
                    <button className='btn btn-sm btn-success mx-1' onClick={() => setActualizar(!actualizar)}>
                        <i className="fa-solid fa-magnifying-glass"></i> Cargar</button>
                </div>
            </div>
            {fecha != '' && <div className='table-responsive'>
                <table className="table table-sm table-dark table-bordered border-4" id='invHisTabla'>
                    <thead>
                        <tr className='text-center'>
                            <th>SUCURSALES</th>
                            <th>PECH+ALA</th>
                            <th>PIER+ENTRE</th>
                            <th>BANDEJAS Pollo</th>
                            <th>PIPOCA</th>
                            <th>PAPA</th>
                            <th>ARROZ</th>
                            <th>FRIJOL</th>
                            <th>FRUTI</th>
                            <th>MARAC</th>
                            <th>MANGO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item, index) => {
                            return (
                                <ItemSucursalRe sucursal={item} actualizar={actualizar} regional={regional} fecha={fecha} 
                                    idUsuario={idUsuario} key={index} callback={()=>actualizarSuma()} />
                            )                        
                        })}
                    </tbody>
                    {(numFila > 0) && <tfoot className='fondoMostasa text-center'>
                        <tr className='fondoMostasa'>
                            <th></th>
                            <th>{parseInt(sumarValores(0))}</th>
                            <th>{parseInt(sumarValores(1))}</th>
                            <th>{sumarValores(2)}</th>
                            <th>{parseInt(sumarValores(3))}</th>
                            <th>{parseInt(sumarValores(4))}</th>
                            <th>{parseInt(sumarValores(5))}</th>
                            <th>{parseInt(sumarValores(6))}</th>
                            <th>{sumarValores(7).toFixed(2)}</th>
                            <th>{sumarValores(8).toFixed(2)}</th>
                            <th>{sumarValores(9).toFixed(2)}</th>
                        </tr>
                    </tfoot>}
                </table>
            </div>}
        </>
    )
}

export default HistoricoInventarioTr